import { Tab, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { GridsterWidget } from '../../vo/workingzone/gridster-widget';
import { TranslatableLabelVO } from '../../vo/common/translation/translatable-label.vo';
import { ViewData } from '../../model/view.data';
import { PhysicalTemplateVO } from './physical-template.vo';
import { entity, field } from '@wizeoo/akm-compute-lib';
import { Model } from '../..//model/model';
// import { Observable } from 'rxjs';
// import { AttachmentService } from '../../command/core/attachment/attachment.service';


@entity('wizeoo.allkeyme.workingdata.message.Tab', 'VISION')
export class TabVO {
  
  protected _model: Model = null;
  public get model(): Model {
    return this._model;
  }
  public set model(value: Model) {
      this._model = value;
  }

  constructor(model: Model, public source: Tab = new Tab()) {
    this._model = model;
  }

  public set uid(uid: string) {
    this.source.uid = uid;
  }
  public get uid(): string {
    return this.source.uid;
  }

  // Id technique
  public get id(): number {
    return this.source.id;
  }
  public set id(value: number) {
    this.source.id = value;
  }

  public set domain(domain: string) {
    this.source.domain = domain;
  }

  public get domain(): string {
    return this.source.domain;
  }

  /** accesseurs sur BusinessUnit */
  get businessUnitCode(): string {
    return this.source.businessUnitCode;
  }
  set businessUnitCode(value: string) {
    this.source.businessUnitCode = value;
  }

  /** accesseurs sur le code */
  @field('string')
  public set code(code: string) {
    this.source.code = code ? code.toUpperCase() : code;
  }
  public get code(): string {
    return this.source.code;
  }

  // TODO : détecter les changements sur les sous-collections
  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu de steps
  public get maintenanceFlag(): string {
    return this.source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this.source.maintenanceFlag = value;
  }

  /** accesseur sur libellé traduit */
  get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.code);
  }

  /** accesseur sur desc traduit */
  get trsDesc(): string {
    return this.model.localeEngine.translate(this.description);
  }

  get featureCode(): string {
    return this.visionCode + ViewData.KEY_SEPARATOR + this.code;
  }

  /** accesseurs sur deleted (logique) */
  @field('boolean')
  get deleted(): boolean {
    return this.source.deleted;
  }
  set deleted(value: boolean) {
    this.source.deleted = value;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this.source.description = value;
  }
  public get description(): TranslatedEmb {
    return this.source.description;
  }

  @field('string')
  public get owner(): string {
    return this.source.owner;
  }
  public set owner(value: string) {
    this.source.owner = value;
  }

  @field('string')
  public get visionCode(): string {
    return this.source.visionCode;
  }

  public set visionCode(value: string) {
    this.source.visionCode = value;
  }

  @field('string')
  public get physTempCode(): string {
    return this.source.physTempCode;
  }

  public set physTempCode(value: string) {
    this.source.physTempCode = value;
  }

  @field('string')
  public get color(): string {
    return this.source.color;
  }
  public set color(value: string) {
    this.source.color = value;
  }

  @field('string')
  public get icon(): string {
    return this.source.icon;
  }
  public set icon(value: string) {
    this.source.icon = value;
  }

  @field('number')
  public get viewOrder(): number {
    return this.source.viewOrder;
  }
  public set viewOrder(value: number) {
    this.source.viewOrder = value;
  }

  get exists(): boolean {
    return this.source.id !== undefined && this.source.id >= 0;
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = this.model.localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  private _template: PhysicalTemplateVO = null;
  public get template(): PhysicalTemplateVO {
    if (!this._template) {
      this._template = this.model.physicalTemplateEngine.getTemplate(this.physTempCode);
    }
    return this._template;
  }

  // les widgets avec le contrat d'interface gridster
  private _gridsters: GridsterWidget[] = null;

  public get widgets(): GridsterWidget[] {
    if(!this._gridsters) {
      if(!!this.template) {
        this._gridsters = this.template.widgets;
      } else {
        this._gridsters = [];
      }
    }
    return this._gridsters;
  }

    /**
   * icone du tab
   * @param vision 
   * @returns 
   */
  //   public getIconOrDie(): Observable<string> {
  //   // observable sur l'icone
  //   let iconOrDie: Observable<string> = null;
  //   iconOrDie = AttachmentService.getInstance().iconOrDie(ViewData.settingsIcon, this.domain, this.businessUnitCode, ViewData.wildcardMainVision);
  //   return iconOrDie;
  // } 

}
